import React from 'react';

function IframeComponent({ src, height, width }) {
    const iframeStyle = {
        width: width || '100%',
        height: height || '100%',
        border: 0,
        frameborder: 0,
        marginheight: 0,
        marginwidth: 0,
        scrolling: "auto"
    }

    const containerStyle = {
        height: '100%',
        width: '100%'
    }


    return (
        <div style={containerStyle}>
          <iframe 
              src={src}
              style={iframeStyle}
              allowfullscreen
          />
        </div>
    );
}

export default IframeComponent;
